<template>
  <!-- 订单汇总 -->
  <div class="orderDetails">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="getTableData('refersh')"
      :crumbsList="['订单管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="exportData"
          >导出数据</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">单据状态：</label>
        <el-select
          style="width: 100px"
          class="search-item-input"
          placeholder="单据状态"
          v-model="searchForm.orderStatus"
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <label class="label">支付类型：</label>
        <el-select
          style="width: 100px"
          class="search-item-input"
          v-model="searchForm.payType"
          placeholder="支付类型"
        >
          <el-option label="全部" :value="99"></el-option>
          <el-option
            v-for="item in payType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          class="search-item-input"
          v-model="searchForm.startDate"
          placeholder="起始日期"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-date-picker
          class="search-item-input"
          v-model="searchForm.endDate"
          placeholder="截止日期"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-input
          class="search-item-input"
          v-model="searchForm.orderNo"
          clearable
          placeholder="订单编号"
        >
        </el-input>
        <el-input
          class="search-item-input"
          v-model="searchForm.goodsName"
          clearable
          placeholder="商品名称"
        >
        </el-input>
        <el-button
          style="margin-left: 10px"
          type="primary"
          icon="el-icon-search"
          @click="getTableData('search')"
          >搜索
        </el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column
        prop="OrderNo"
        align="center"
        show-overflow-tooltip
        label="订单编号"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="AddTime"
        align="center"
        show-overflow-tooltip
        label="时间"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="OrderStatus"
        show-overflow-tooltip
        label="状态"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="BusinessCode"
        show-overflow-tooltip
        label="客户编号"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="BusinessName"
        show-overflow-tooltip
        label="单位名称"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="PayType"
        show-overflow-tooltip
        label="支付方式"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="GoodsCode"
        show-overflow-tooltip
        label="商品编号"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="GoodsName"
        show-overflow-tooltip
        label="商品名称"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="DrugFactory"
        show-overflow-tooltip
        label="生厂厂家"
        width="150"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="DrugSpec"
        show-overflow-tooltip
        label="规格"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="Quantity"
        show-overflow-tooltip
        label="商品数量"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="OutNum"
        show-overflow-tooltip
        label="出库数量"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="Price"
        show-overflow-tooltip
        label="价格"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="TaxAmount"
        show-overflow-tooltip
        label="含税金额"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="levelName1"
        show-overflow-tooltip
        label="省代"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="levelName2"
        show-overflow-tooltip
        label="市代"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="levelName3"
        show-overflow-tooltip
        label="业务员"
      >
      </el-table-column>
      <el-table-column
        align="center"
        prop="levelName4"
        show-overflow-tooltip
        label="推广员"
      >
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
//混入
export default {
  name: "orderDetails",
  data() {
    return {
      /**搜索 */
      searchForm: {
        payType: 99,
        orderNo: "",
        goodsName: "",
        startDate: "",
        endDate: "",
        orderStatus: "99", //
      },

      statusList: [], //订单状态

      payType: [], //支付方式列表

      /**表格数据 */
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
    };
  },

  mounted() {
    const originalStatusList = this.$store.state.ORDER_STATUS; //订单状态
    this.statusList = originalStatusList.map(item => {
    // 修正已发货的映射
    if (item.label === '已发货') {
      return { ...item, value: '6' }; // 强制改为6
    }
    // 修正已收货的映射
    if (item.label === '已完成') {
      return { ...item, value: '7' }; // 强制改为7
    }
    return item;
    });
    this.getTableData("refresh");
    this.getPayType();
  },
  activated() {
    // 从缓存中获取是否存在订单查询条件(从首页传来)
    let keyword = window.sessionStorage.getItem("keyword");
    // console.log('keyword', keyword);

    if (keyword) {
      window.sessionStorage.removeItem("keyword");
      if (this.statusList && this.statusList.length > 0) {
        const trimmedKeyword = keyword.trim();
        const statusMapping = {
        '待付款': '1',
        '已审核': '2',
        '待处理': '3',
        '已出库': '4',
        '已发货': '6',
        '已完成': '7',
        '已退货': '10',
        '已退款': '11',
        };
        // 使用映射关系查找
        if (statusMapping[trimmedKeyword]) {
          this.searchForm.orderStatus = statusMapping[trimmedKeyword];
        } else {
          this.searchForm.orderStatus = "99";
        }

        // 立即执行搜索
        this.$nextTick(() => {
          this.getTableData(1);
        });
      }

      //延时触发
      let timer = setTimeout(() => {
        this.getTableData();
        clearTimeout(timer);
        timer = null;
      }, 300);
    }
  },
  methods: {
    /**导出数据 */
    exportData() {
      // 参数和查询的一样
      this.$request({
        url: "/Management/OrderAdmin/ToExcelOrderDetailApi",
        method: "get",
        responseType: "blob",
        params: {
          endDate: this.searchForm.endDate,
          pageIndex: this.currPage,
          pageSize: this.pageSize,
          payType: this.searchForm.payType,
          status: this.searchForm.orderStatus,
          orderNo: this.searchForm.orderNo,
          startDate: this.searchForm.startDate,
          goodsName: this.searchForm.goodsName,
        },
      })
        .then((res) => {
          // console.log(res);
          const $link = document.createElement("a");
          $link.href = URL.createObjectURL(res);
          $link.download = "订单明细_" + new Date().getTime() + ".xlsx";
          //文件的名称加后缀名
          $link.click();
          $link.remove(); // 删除创建的标签
          URL.revokeObjectURL($link.href); // 释放创建的url对象
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**获取表格数据 */
    getPayType() {
      let data = {
        entId: localStorage.getItem("entId"),
      };
      this.$request({
        url: "Base/GetEntPayTypeList",
        method: "post",
        data: data,
      }).then((res) => {
        if (res.success) {
          this.payType = res.list.map((item) => ({
            value: item.PayId,
            label: item.PayType,
          }));
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },

    /**获取表格 */
    getTableData(type = "") {
      if (type == "refresh") {
        this.currPage = 1;
        this.searchForm.endDate = "";
        this.searchForm.payType = 99;
        this.searchForm.orderNo = "";
        this.searchForm.goodsName = "";
        this.searchForm.startDate = "";
        this.searchForm.orderStatus = "99";
      } else if (type == "search") {
        this.currPage = 1;
      }

      this.$request({
        url: "/Management/OrderAdmin/OrderDtAnalysisApi",
        method: "post",
        data: {
          endDate: this.searchForm.endDate,
          pageIndex: this.currPage,
          pageSize: this.pageSize,
          payType: this.searchForm.payType,
          status: this.searchForm.orderStatus,
          orderNo: this.searchForm.orderNo,
          startDate: this.searchForm.startDate,
          goodsName: this.searchForm.goodsName,
        },
      })
        .then((res) => {
          if (res.success) {
            this.tableData = res.dateList;
            this.allPage = res.toTal;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },

    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
  },
};
</script>

<style scoped>
.orderDetails {
  width: 100%;
  height: 100%;
}

/**搜索输入框 */
.search-item-input {
  width: 150px;
  margin-left: 5px;
}

/**自定义表格内容，图片上下居中问题 */
.table-column {
  display: flex;
  justify-content: center;
  align-items: center;
}

/**消息回复 */
.msg {
}

.msg-tit {
  font-size: 16px;
}

.msg-item {
  margin-top: 10px;
  text-indent: 30px;
}

.msg-send {
  height: 150px;
  padding: 10px 0;
  box-sizing: border-box;
}

.msg-send-btns {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
